import type { ButtonProps } from "@simplybusiness/mobius";
import { Button, Modal } from "@simplybusiness/mobius";
import { useState } from "react";
import { useTriggerEventTracker } from "./helpers/PersistentPaymentSummaryHelper";

export const DialogueModal = ({
  redirectFunction,
  headerText,
  description,
  actionButtonText,
  cancelButtonText,
  button,
}: DialogueProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [loading, setIsLoading] = useState(false);
  const [eventName, setEventName] = useState<string | null>(null);

  useTriggerEventTracker(eventName);

  const handleOpenModal = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    setOpenModal(true);
  };

  const handleCancelButtonClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    setOpenModal(false);
    setEventName("cancel_return_to_checkout_button_clicked");
  };

  const handleActionButtonClick = () => {
    setIsLoading(true);
    setEventName("go_back_to_quote_selection_clicked");
    redirectFunction();
  };

  return (
    <>
      <Button size="sm" {...(button?.props || {})} onClick={handleOpenModal} />
      <Modal isOpen={openModal} onClose={() => setOpenModal(loading)}>
        <Modal.Header>{headerText}</Modal.Header>
        <Modal.Content>
          {description}
          <div className="mobius-payment-summary__button-div">
            <Button
              variant="secondary"
              size="sm"
              isLoading={loading}
              isDisabled={loading}
              onPress={handleActionButtonClick}
            >
              {actionButtonText}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              isDisabled={loading}
              onClick={handleCancelButtonClick}
            >
              {cancelButtonText}
            </Button>
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
};

export type DialogueProps = {
  redirectFunction: () => void;
  headerText: string;
  description: string;
  actionButtonText: string;
  cancelButtonText: string;
  button: { props: ButtonProps };
};
